import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { CacheProvider } from "@emotion/react";
import theme from "src/configs/theme/theme";
import createCache from "@emotion/cache";
import Router from "src/routes/Router";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import { Provider } from "react-redux";
import { store } from "src/app/store";
import { ToastContainer } from "react-toastify";
import React from 'react';
import "react-toastify/dist/ReactToastify.css";

export default function App() {
  //test comment
  return (
    <CacheProvider
      value={createCache({
        key: "muirtl",
        stylisPlugins: [prefixer, rtlPlugin],
      })}
    >
      <CssBaseline />
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <ToastContainer limit={3} position="top-left" />
          <Router />
        </Provider>
      </ThemeProvider>
    </CacheProvider>
  );
}
